import type { Till } from "~/api/tills/types";
import type { WebEvent } from "~/types/events";
import { FREEDOMPAY_RECEIPT_FORMAT } from "~/utils/constants";

type FreedomPaySyncPayload = Extract<
  WebEvent,
  { type: "FREEDOMPAY_OPEN_SETTINGS_REQUEST" | "FREEDOMPAY_TILL_SYNC_REQUEST" }
>["payload"];

export const getFreedomPaySyncPayload = (
  till: Till
): FreedomPaySyncPayload | null => {
  const config = till.paymentGatewayConfig;
  if (
    config?.provider !== "freedompay" ||
    !config.storeId ||
    !config.terminalId ||
    !config.esKey ||
    !config.activationKey
  ) {
    return null;
  }

  return {
    tillId: till.id,
    storeId: config.storeId,
    terminalId: config.terminalId,
    esKey: config.esKey,
    activationKey: config.activationKey,
    currencyISOCode: till.currency,
    languageCode: till.language,
    receiptFormat: FREEDOMPAY_RECEIPT_FORMAT[till.country] || "FRANCE"
  };
};
